import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { usePurchasesDetailModel } from "./purchasesDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { Button, message, Modal, Radio } from "antd";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { getFormValidatorErrText } from "@/utils/utils";
import { IPurchaseExamine } from '../../purchasesTypes';
import TextArea from 'antd/lib/input/TextArea';
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { DictCodeEnmu } from "@/types/AppDictEnums";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const { editFormVal,
        editFormVal: { status },
        getPurchaseDetailOne,
        resetPageCache,
        examineManager,
        whConfirm, exportDetails, submitPurchase,
        setSettleVisible, examineReckoner, insertOrUpdatePurchase } = usePurchasesDetailModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const isEdit = mode === "edit";

    useEffect(() => {
        if (!editFormVal.id && isEdit) {
            getPurchaseDetailOne(id)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("3-1") && resetPageCache("add")
            !findNav("3-2") && resetPageCache("edit");
        }
    }, [selectedNavId])

    const orderStatu: IDescription[] = [
        {
            label: "采购合同",
            value: editFormVal.purchaseCode ?? editFormVal.code,
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "驳回原因",
            value: status === DictCodeEnmu.PURCHASE_DIR_REJECT ? editFormVal.advise ?? "" : editFormVal.adviseOne ?? "",
            color: DescriptionColorEnum.red,
            status: true,
            hidden: !(status === DictCodeEnmu.PURCHASE_DIR_REJECT || status === DictCodeEnmu.PURCHASE_FIN_REJECT) //财务 或者 总监已驳回时  展示驳回原因
        }
    ]
    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            insertOrUpdatePurchase(mode, val).then(res => {
                if (mode === "add" && res) {
                    resetPageCache("edit");
                    replaceNav("4-1", "4-2", { id: res as string, mode: "edit" });
                }
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };

    //审批弹框
    const examineModal1 = (title: string) => {
        let obj: IPurchaseExamine = {
            status: "0",//默认是同意
            title
        }
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { obj.advise = e.target.value }} />
                <Radio.Group onChange={(e) => { obj.status = e.target.value }} defaultValue={obj.status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    // if (obj.advise) {
                    resolve(obj);
                    // } else {
                    //     message.warning("请输入审批意见");
                    //     reject('请输入审批意见');
                    // }
                }).then((res: any) => {
                    examineManager({
                        code: editFormVal.code,
                        status: res.status,
                        advise: res.advise,
                    })
                });
            },
            onCancel: () => { }
        })
    }

    //审批弹框
    const examineModal2 = (title: string) => {
        let obj: IPurchaseExamine = {
            status: "0",//默认是同意
            title
        }
        Modal.confirm({
            title: title,
            content: <>
                <TextArea rows={4} placeholder="请输入审批意见" onChange={(e) => { obj.advise = e.target.value }} />
                <Radio.Group onChange={(e) => { obj.status = e.target.value }} defaultValue={obj.status}>
                    <Radio value={"0"}>同意</Radio>
                    <Radio value={"1"}>驳回</Radio>
                </Radio.Group>
            </>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    // if (obj.advise) {
                    resolve(obj);
                    // } else {
                    //     message.warning("请输入审批意见");
                    //     reject('请输入审批意见');
                    // }
                }).then((res: any) => {
                    examineReckoner({
                        code: editFormVal.code,
                        status: res.status,
                        advise: res.advise,
                    })
                });
            },
            onCancel: () => { }
        })
    }

    const action = <>
        {isEdit && <>
            <YhAuth resCode={ResourceAuthEnum.P_ED_SUBMIT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={
                        !(status === DictCodeEnmu.PURCHASE_INIF ||
                            status === DictCodeEnmu.PURCHASE_FIN_REJECT ||
                            status === DictCodeEnmu.PURCHASE_DIR_REJECT)
                    }
                    onClick={() => { submitPurchase() }}
                >提交</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_ED_APPROVE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.PURCHASE_PEND_APPROVE)}
                    onClick={() => examineModal1("总监审批")}
                >总监审批</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_ED_FIN_APPROVE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.PURCHASE_DIR_APPROVE)}
                    onClick={() => examineModal2("财务审核")}
                >财务审核</Button>
            </YhAuth>
            {/* <YhAuth resCode={ResourceAuthEnum.P_ED_EXPORT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.PURCHASE_PEND_SETTLE || status === DictCodeEnmu.PURCHASE_SETTLE)}
                    onClick={() => { exportDetails() }}
                >导出采购合同</Button>
            </YhAuth> */}
            <YhAuth resCode={ResourceAuthEnum.P_ED_SETTLE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.PURCHASE_PEND_SETTLE)}
                    onClick={() => { setSettleVisible(true) }}
                >结算</Button>
            </YhAuth>
            {/* <YhAuth resCode={ResourceAuthEnum.P_ED_WAREHOUSE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={!(status === DictCodeEnmu.PURCHASE_SETTLE)}
                    onClick={() => { whConfirm() }}
                >入库</Button>
            </YhAuth> */}
        </>}
        <YhAuth resCode={ResourceAuthEnum.P_ED_SAVE} isShow={mode === "add"}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { onSubmit() }}
            >保存</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "4")}
        >返回</Button>
    </>

    return (
        <YhBox title={orderStatu.map((item, index) => <Description key={index} {...item} />)}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}